import * as React from "react"
import { Link, graphql } from "gatsby"

import Bio from "../components/bio"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Skills from "../components/skills"

const BlogIndex = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata?.title || `Title`
  const posts = data.allMarkdownRemark.nodes

  if (posts.length === 0) {
    return (
      <Layout location={location} title={siteTitle}>
        <Seo title="Front-end developer" />
        <h1 className="visually-hidden">Onur Boz</h1>
        <div className="container container-max-md">
          <Link title="Go to about page" className="link-light" to="/about">
            <Bio />
          </Link>
        </div>
        <p>
          No blog posts found.
        </p>
      </Layout>
    )
  }

  return (
    <Layout location={location} title={siteTitle}>
      <Seo title="Front-end developer" />
      <h1 className="visually-hidden">Onur Boz</h1>
      <div className="container container-max-md">
        <Link title="Go to about page" className="link-light" to="/about">
          <Bio />
        </Link>
      </div>
      <div className="overflow-hidden">
        <Skills />
      </div>
      <div className="container container-max-md mt-5">
        <h4 className="text-center h2">Recent Blog Posts</h4>
        <ol className="list-unstyled row g-3">
          {posts.map(post => {
            const title = post.frontmatter.title || post.fields.slug
            return (
              <li className="col-md-6" key={post.fields.slug}>
                <article
                  className="post-list-item"
                  itemScope
                  itemType="http://schema.org/Article"
                >
                  <header>
                    <h2 className="h4">
                      <Link to={post.fields.slug} itemProp="url">
                        <span itemProp="headline">{title}</span>
                      </Link>
                    </h2>
                    <p className="text-muted mt-n4">
                      <small>{post.frontmatter.date}</small>
                    </p>
                  </header>
                  <section className="entry">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: post.frontmatter.description || post.excerpt,
                      }}
                      itemProp="description"
                    />
                  </section>
                </article>
              </li>
            )
          })}
        </ol>
      </div>
    </Layout>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC },
      filter: {fileAbsolutePath: {regex: "/(\/content\/blog)/.*.md$/"}}
      ) {
      nodes {
        excerpt
        fields {
          slug
        }
        frontmatter {
          date(formatString: "MMMM DD, YYYY")
          title
          description
        }
      }
    }
  }
`
